module.exports = __webpack_public_path__ + "static/img/bus-content-9.ddb15b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus-content-9.jpg
// module id = Xu0i
// module chunks = 0